"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _segmentToggle = _interopRequireDefault(require("../../../elements/other/segment-toggle"));
var _planBoxSubscriptionItem = _interopRequireDefault(require("./plan-box-subscription-item"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _scrollIndicator = _interopRequireDefault(require("./scroll-indicator"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */

/**
 * Local Imports
 */

const RootContainer = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "RootContainer",
  class: "pl-r1f04nwc"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)(_index.default)({
  name: "HeadlineWrapper",
  class: "pl-hq5kfrh"
});
const CardContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardContainer",
  class: "pl-cmlix2y",
  vars: {
    "cmlix2y-0": [({
      col
    }) => col],
    "cmlix2y-1": [({
      hasFlag
    }) => hasFlag ? 'var(--fixed-space-500)' : '0'],
    "cmlix2y-4": [({
      col
    }) => {
      if (col === 4) {
        return `100vw`;
      } else if (col === 3) {
        return `83rem`;
      } else if (col === 2) {
        return `60rem`;
      }
      return `35rem`;
    }]
  }
});
const CTAContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CTAContainer",
  class: "pl-ch9hl62"
});

/**
 * PlanboxSubscription Component.
 * @module PlanboxSubscription
 * @deprecated This component is deprecated. Please use SimplePlanBoxSection instead.
 * @param {Object} props React props
 * @param {String} props.id The id of the content item
 * @param {Object} props.headlineContent Headline Fields
 * @param {Array} props.items Plan Cards Array
 * @param {Boolean} props.hasToggle Toggle Condition Statement
 * @param {String} props.toggleLeftText Toggle Default Label
 * @param {String} props.toggleRightText Toggle Set Label
 * @param {String} props.toggleTagText Toggle Tag Label
 * @param {String} props.ToggleDisclaimer Toggle Disclaimer
 * @param {Object} props.cta Main Cta
 * @param {string} props.verticalMargin Vertical Layout Spacing Values
 * @returns {React.ReactElement} PlanboxSubscription Component
 * @public
 */

function PlanboxSubscription({
  id,
  _name,
  headlineContent,
  items,
  hasToggle,
  toggleLeftText,
  toggleRightText,
  toggleTagText,
  toggleDisclaimer,
  cta,
  reverseDefault = false,
  verticalMargin
}) {
  const [toggled, setToggled] = (0, _react.useState)(reverseDefault);
  const target = /*#__PURE__*/_react.default.createRef();
  const hasImages = !!items?.find(i => i.image);
  return /*#__PURE__*/_react.default.createElement(RootContainer, {
    dataCy: "plan-box-subscription",
    padding: "none",
    textAlign: "center",
    verticalMargin: verticalMargin,
    _name: _name
  }, headlineContent && /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "content-item"
  }, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, headlineContent)), hasToggle && /*#__PURE__*/_react.default.createElement(_segmentToggle.default, {
    id: id,
    changeHandler: e => setToggled(e?.target?.value === 'toggled'),
    toggled: toggled,
    toggleLeftText: toggleLeftText,
    toggleRightText: toggleRightText,
    toggleTagText: toggleTagText,
    toggleDisclaimer: toggleDisclaimer
  }), items && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(CardContainer, {
    "data-cy": "card-container",
    hasFlag: items.reduce((anyFlags, {
      flag
    }) => anyFlags || flag, false),
    col: items.length,
    ref: target
  }, items?.slice(0, 4)?.map(({
    price,
    priceToggled,
    cta: itemCta,
    ctaToggled,
    description,
    descriptionToggled,
    planTagText,
    planTagTextToggled,
    ...rest
  }, idx) => /*#__PURE__*/_react.default.createElement(_planBoxSubscriptionItem.default, (0, _extends2.default)({
    col: idx + 1,
    key: idx,
    showImageWrapper: hasImages,
    cta: toggled ? ctaToggled : itemCta,
    description: toggled ? descriptionToggled ?? description : description,
    planTagText: toggled ? planTagTextToggled ?? planTagText : planTagText,
    price: toggled ? priceToggled : price
  }, rest)))), items?.length > 1 && /*#__PURE__*/_react.default.createElement(_scrollIndicator.default, {
    elementArr: items.length,
    element: target
  })), cta && /*#__PURE__*/_react.default.createElement(CTAContainer, null, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, (0, _extends2.default)({}, cta, {
    width: "full"
  }))));
}
var _default = exports.default = PlanboxSubscription;
PlanboxSubscription.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  headlineContent: _propTypes.default.shape(_index.default.propTypes),
  items: _propTypes.default.array,
  hasToggle: _propTypes.default.bool,
  toggleLeftText: _propTypes.default.string,
  toggleRightText: _propTypes.default.string,
  toggleTagText: _propTypes.default.string,
  toggleDisclaimer: _propTypes.default.string,
  cta: _propTypes.default.object,
  reverseDefault: _propTypes.default.bool,
  ..._patternLibraryUtils.marginProps
};